import axios from 'axios';
import userManager from '../auth/userManagerInstance';
import { store } from '../store.js';
import { eventBus } from '../main.js';

const cancelTokens = [];

const protectedAxios = axios.create({
  baseURL: window._env_config.API_URL,
});

//nastavi Authorization hlavicku
protectedAxios.interceptors.request.use(
  config => {
    const accessToken = store.getters['auth/accessToken'];
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    const source = axios.CancelToken.source();
    config.cancelToken = source.token;
    if(!config.url.includes("login/")){
      cancelTokens.push(source);
    }

    return config;
  },
  error => {
    Promise.reject(error);
  }
);

const removeCancelToken = (token) => {
  const index = cancelTokens.indexOf(token);
  if (index !== -1) {
    cancelTokens.splice(index, 1);
  }
};

protectedAxios.interceptors.response.use(
  response => {
    removeCancelToken(response.config.cancelToken);
    return response
  },
  error => {
    if (error.config && error.config.cancelToken) {
      removeCancelToken(error.config.cancelToken);
    }
    // whatever you want to do with the error
    const f = new Intl.DateTimeFormat('sk', { dateStyle: 'short', timeStyle: 'medium' });
    if (error?.response?.status === 500 && error?.response?.data) {    
      const time = error?.response?.data?.time ? error?.response?.data.time : f.format(new Date());
      let message = `Na serveri nastala neočakávaná chyba. Čas: ${time}`;

      if (error?.response?.data.message) message = `${error?.response?.data.message} Čas: ${time}`;

      eventBus.$emit('snack-error-i', message);
    }
    if (error?.response?.status === 403 && error?.response?.data) {
      const time = error?.response?.data?.time ? error?.response?.data.time : f.format(new Date());
      let message = `Na serveri nastala neočakávaná chyba. Čas: ${time}`;

      if (error?.response?.data.errorText) message = `${error?.response?.data.errorText} Čas: ${time}`;

      eventBus.$emit('snack-error-i', message);
      cancelTokens.forEach(cancelToken => cancelToken.cancel('Nemá právo'));
      cancelTokens.length = 0; 
      if(window._env_config.DEBUG)
        console.log(error.config.headers.Authorization);
    }
    error.onlyInterceptor = error?.response?.data?.onlyInterceptor ?? false;
    return Promise.reject(error);
  }
);

//vytvori parametre do URL
protectedAxios.generateUrlParameters = function (obj) {
  if (!obj) return '';

  let paramString = '';
  Object.entries(obj).forEach(entry => {
    const [k, v] = entry;
    if (v) paramString += `${k}=${v}&`;
  });

  return paramString ? `?${paramString}`.slice(0, -1) : '';
};

//pokusi sa ziskat novy token, ak volanie nebolo uspesne a zopakuje
protectedAxios.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    const firstRequest = error.config;
    if (error.response !== undefined) {
      if (error.response.status === 401 && !firstRequest._retry) {
        firstRequest._retry = true;
        await userManager.signinSilent();
        const access_token = store.getters['auth/accessToken'];
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
        return protectedAxios(firstRequest);
      }
    }
    return Promise.reject(error);
  }
);

export default protectedAxios;
